<template>
    <div id="app">
      <header>
        <HeaderV />
      </header>
      <main>
        <FormulairePaiement />
      </main>
      <footer>
        <FooterV />
      </footer>
    </div>
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  import HeaderV from "@/components/Landing/HeaderV.vue";
  import FormulairePaiement from "@/components/Landing/FormulairePaiement.vue";
  import FooterV from "@/components/Landing/FooterV.vue";
  
  export default defineComponent({
    name: "ProcessPaiement",
    components: {
      HeaderV,
      FormulairePaiement,
      FooterV,
    },
  });
  </script>
  
  <style scoped>
  /* Si nécessaire, ajoutez des styles locaux */
  header {
    background-color: #1c462e; /* Exemple de couleur pour distinguer le header */
  }
  
  main {
    padding: 20px; /* Ajoutez un espace pour éviter les chevauchements */
  }
  
  footer {
    background-color: #f8f9fa; /* Exemple de couleur pour distinguer le footer */
    padding: 10px;
    text-align: center;
  }
  </style>
  